import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from "classnames";
import { LongArrowForwardIcon } from "@jti/brand-icons/long-arrow-forward";
import { LinkBehaviour } from "../../../../../../components/LinkBehaviour";
import styles from "./RedirectionLinkCard.module.scss";
export const RedirectionLinkCard = ({ image, title, link, onClick, variant = "list", className, isArrowHidden, }) => {
    const isArrowShown = variant === "list" && !isArrowHidden;
    return (_jsx("div", { className: classNames(styles.redirectionCardLink, className, {
            [styles.ploomClub]: variant === "ploomClub",
            [styles.list]: variant === "list",
        }), onClick: onClick, children: _jsxs(LinkBehaviour, { href: link, children: [_jsx("span", { className: styles.title, children: title }), isArrowShown && (_jsx(LongArrowForwardIcon, { className: styles.arrowIcon, direction: "ltr", "data-testid": "icon-chevron-right" })), variant === "withImage" && image && (_jsx("div", { className: styles.imageContainer, "data-testid": "redirection-link-card-image", style: {
                        backgroundImage: `url('${image}')`,
                    } }))] }) }));
};
//# sourceMappingURL=RedirectionLinkCard.js.map